/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getTranslation } from '@/store/getters'
import { setActivePage, setElements } from '@/store/actions'
import { togglePageOrder } from '@/store/actions/ui'
import { rawElementFactory } from '@/components/commons/editor/EditorFactory'

import styles from './styles.scss'

import { PopOver } from '@/components/commons/PopOver'

class Thumbnail extends Component {

  state = {
    showMenu: false,
    position: 'right'
  }

  onActivePage = (event) => {
    const { item, setActivePage, setElements, togglePageOrder } = this.props
    if (event && event.detail === 2) {
      togglePageOrder({
        isOpened: false
      })
    }
    setActivePage(item)
    setElements(item.items)
  }

  getElements = items => {
    const elements = items
      .map(item => {
        const content =
          typeof item.content === 'string'
            ? JSON.parse(item.content)
            : item.content
        return rawElementFactory(content)
      })
      .join()
    return { __html: elements }
  }

  handleContextMenu = (event) => {
    event.preventDefault();
    this.onActivePage()
    this.setState({ showMenu: true })
  };

  refCallback = el => {
    const { wrapperPageOrderRef } = this.props

    if (el && wrapperPageOrderRef) {
      const a = wrapperPageOrderRef.current.getBoundingClientRect()
      const b = el.getBoundingClientRect()
      if (b.right >= a.right) {
        this.setState({ position: 'left' })
      } else if (b.left <= a.left) {
        this.setState({ position: 'right' })
      }
    }
  };

  render() {
    // drag methods
    const { showMenu, position } = this.state
    const { translation, page_id, index, item, dragCallbacks, onDragEnd, handleEdit, handleDuplicate, handleDelete, items, selected } = this.props
    const { onStartDrag, onDragOver, onDragEnter, onDragLeave } = dragCallbacks
    let { properties } = item
    if (typeof properties === 'string') properties = JSON.parse(properties)

    return (
      <div className={styles['wrapper']}>
        <div
          page_id={page_id}
          key={index}
          className={`${styles['wrapper__thumbnail']} ${index === selected ? styles['wrapper__thumbnail__active'] : undefined}`}
          index={this.props.index}
          draggable="true"
          onDragStart={e => onStartDrag(e, { page_id, index })}
          onDragOver={e => onDragOver(e, { page_id, index })}
          onDragEnter={e => onDragEnter(e)}
          onDragLeave={e => onDragLeave(e)}
          onDragEnd={onDragEnd}
          onClick={this.onActivePage}
          style={properties}
          onContextMenu={this.handleContextMenu}
        >

          <div className={styles['wrapper__thumbnail__block']} />
          <div
            className={styles['wrapper__thumbnail__elements']}
            dangerouslySetInnerHTML={this.getElements(items)}
          />

        </div>
        <span className={styles['wrapper__index']}>{this.props.index + 1}</span>
        {showMenu &&
          <PopOver
            className={`ba-card ba-300 ${styles['wrapper__popover']} ${styles['wrapper__popover__' + position]}`}
            hidePopover={() => this.setState({ showMenu: false })}
          >
            <ul className='ba-w-100' ref={this.refCallback}>
              <li className='ba-flex ba-ai-center ba-color-hover-blue1 ba-bg-hover-blue14 ba-pd-1'
                onClick={handleEdit}
              >
                <builderall-icon code='edit' class='ba-sm-icon' />
                <span className='ba-mg-l-1'>
                  {translation('general-edit')}
                </span>
              </li>
              <li className='ba-flex ba-ai-center ba-color-hover-blue1 ba-bg-hover-blue14 ba-pd-1'
                onClick={handleDuplicate}
              >
                <builderall-icon code='f5ff' class='ba-sm-icon' />
                <span className='ba-mg-l-1'>
                  {translation('general-duplicate')}
                </span>
              </li>
              <li className='ba-flex ba-ai-center ba-color-hover-blue1 ba-bg-hover-blue14 ba-pd-1'
                onClick={handleDelete}
              >
                <builderall-icon code='trash' class='ba-sm-icon' />
                <span className='ba-mg-l-1'>
                  {translation('general-delete')}
                </span>
              </li>
            </ul>
          </PopOver>
        }
      </div>
    )
  }
}
const mapStateToProps = state => {
  const translation = getTranslation(state)
  return { translation }
}

export default connect(
  mapStateToProps,
  { setActivePage, setElements, togglePageOrder }
)(Thumbnail)



// WEBPACK FOOTER //
// ./src/components/Thumbnail/index.js